import React from "react";
import {
  Nav,
  Hero,
  AnimatedBrandBanner,
  BrandPillars,
  SocialProof,
  Referrals,
  Leaderboard,
  FinalCTA,
  InviterBanner,
  Footer,
} from "./Landing";
import NewLiveTicker from "@/components/LiveTicker";
import StickyWalkthrough from "@/components/StickyWalkthrough";
import { useSEO } from "@/lib/seo";

export default function Home() {
  useSEO({
    title: "Fun On The Run Plus One — Meet real people through real activities",
    description:
      "No swiping. No fake bios. Live across the US — with flagship pilots in Dallas, Fort Worth, Austin, and New Orleans. Join the beta and find your Plus One.",
    image: "https://activity-connect-24.preview.emergentagent.com/og-home.jpg",
  });
  return (
    <>
      <Nav />
      <div className="relative overflow-x-clip">
      <InviterBanner />
      <Hero />
      <AnimatedBrandBanner />
      <NewLiveTicker />
      <BrandPillars />
      <StickyWalkthrough />
      <SocialProof />
      <Referrals />
      <Leaderboard />
      <FinalCTA />
      <Footer />
    </div>
    </>
  );
}
